/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { MatiereARetraitDto } from '../models/matiere-a-retrait-dto';
import { TypeDechetDto } from '../models/type-dechet-dto';


/**
 * Fonctions de gestion des matières à retrait
 */
@Injectable({
  providedIn: 'root',
})
export class MatieresARetraitService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation matiereARetraitGet
   */
  static readonly MatiereARetraitGetPath = '/api/matiere-a-retrait/{id}';

  /**
   * Renvoie la matière à retrait spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `matiereARetraitGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  matiereARetraitGet$Response(params: {

    /**
     * Identifiant de la matière à retrait
     */
    id: number;
  }): Observable<StrictHttpResponse<MatiereARetraitDto>> {

    const rb = new RequestBuilder(this.rootUrl, MatieresARetraitService.MatiereARetraitGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MatiereARetraitDto>;
      })
    );
  }

  /**
   * Renvoie la matière à retrait spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `matiereARetraitGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  matiereARetraitGet(params: {

    /**
     * Identifiant de la matière à retrait
     */
    id: number;
  }): Observable<MatiereARetraitDto> {

    return this.matiereARetraitGet$Response(params).pipe(
      map((r: StrictHttpResponse<MatiereARetraitDto>) => r.body as MatiereARetraitDto)
    );
  }

  /**
   * Path part for operation matiereARetraitPut
   */
  static readonly MatiereARetraitPutPath = '/api/matiere-a-retrait/{id}';

  /**
   * Met à jour la matière à retrait spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `matiereARetraitPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  matiereARetraitPut$Response(params: {

    /**
     * Identifiant de la matière à retrait à mettre à jour
     */
    id: number;

    /**
     * Matière à retrait
     */
    body: MatiereARetraitDto
  }): Observable<StrictHttpResponse<MatiereARetraitDto>> {

    const rb = new RequestBuilder(this.rootUrl, MatieresARetraitService.MatiereARetraitPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MatiereARetraitDto>;
      })
    );
  }

  /**
   * Met à jour la matière à retrait spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `matiereARetraitPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  matiereARetraitPut(params: {

    /**
     * Identifiant de la matière à retrait à mettre à jour
     */
    id: number;

    /**
     * Matière à retrait
     */
    body: MatiereARetraitDto
  }): Observable<MatiereARetraitDto> {

    return this.matiereARetraitPut$Response(params).pipe(
      map((r: StrictHttpResponse<MatiereARetraitDto>) => r.body as MatiereARetraitDto)
    );
  }

  /**
   * Path part for operation matiereARetraitDelete
   */
  static readonly MatiereARetraitDeletePath = '/api/matiere-a-retrait/{id}';

  /**
   * Supprime l'entité spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `matiereARetraitDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  matiereARetraitDelete$Response(params: {

    /**
     * Identifiant de l&#x27;entité à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, MatieresARetraitService.MatiereARetraitDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Supprime l'entité spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `matiereARetraitDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  matiereARetraitDelete(params: {

    /**
     * Identifiant de l&#x27;entité à supprimer
     */
    id: number;
  }): Observable<void> {

    return this.matiereARetraitDelete$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation matiereARetraitPost
   */
  static readonly MatiereARetraitPostPath = '/api/matiere-a-retrait';

  /**
   * Crée la matière à retrait.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `matiereARetraitPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  matiereARetraitPost$Response(params: {

    /**
     * Matière à retrait
     */
    body: MatiereARetraitDto
  }): Observable<StrictHttpResponse<TypeDechetDto>> {

    const rb = new RequestBuilder(this.rootUrl, MatieresARetraitService.MatiereARetraitPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TypeDechetDto>;
      })
    );
  }

  /**
   * Crée la matière à retrait.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `matiereARetraitPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  matiereARetraitPost(params: {

    /**
     * Matière à retrait
     */
    body: MatiereARetraitDto
  }): Observable<TypeDechetDto> {

    return this.matiereARetraitPost$Response(params).pipe(
      map((r: StrictHttpResponse<TypeDechetDto>) => r.body as TypeDechetDto)
    );
  }

  /**
   * Path part for operation matiereARetraitDesactivate
   */
  static readonly MatiereARetraitDesactivatePath = '/api/matiere-a-retrait/{id}/desactivate';

  /**
   * Désactive la matière à retrait spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `matiereARetraitDesactivate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  matiereARetraitDesactivate$Response(params: {

    /**
     * Identifiant de la matière à retrait à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: MatiereARetraitDto
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, MatieresARetraitService.MatiereARetraitDesactivatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Désactive la matière à retrait spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `matiereARetraitDesactivate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  matiereARetraitDesactivate(params: {

    /**
     * Identifiant de la matière à retrait à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: MatiereARetraitDto
  }): Observable<number> {

    return this.matiereARetraitDesactivate$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation matiereARetraitGetList
   */
  static readonly MatiereARetraitGetListPath = '/api/matiere-a-retrait/list';

  /**
   * Renvoie la liste des entités du type spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `matiereARetraitGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  matiereARetraitGetList$Response(params?: {
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, MatieresARetraitService.MatiereARetraitGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Renvoie la liste des entités du type spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `matiereARetraitGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  matiereARetraitGetList(params?: {
  }): Observable<void> {

    return this.matiereARetraitGetList$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation matiereARetraitLoadList
   */
  static readonly MatiereARetraitLoadListPath = '/api/matiere-a-retrait/load-list';

  /**
   * Renvoie la liste des entités du type spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `matiereARetraitLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  matiereARetraitLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, MatieresARetraitService.MatiereARetraitLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Renvoie la liste des entités du type spécifié (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `matiereARetraitLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  matiereARetraitLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<void> {

    return this.matiereARetraitLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
